const changeFavicon = (link, type = '') => {
  const favicon = document.querySelector('link[rel="icon"]')
  favicon.href = link
  favicon.type = type
}

export default changeFavicon
